import api from '../../../../api/client';

export const SEARCH_FIELD_OPTIONS = [
  { value: 'Name', label: 'Leave Name' },
  { value: 'Alias', label: 'Alias' },
];

export const STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
  { value: 'All', label: 'All Status' },
];

function mapBackendToFrontend(item) {
  if (!item) return null;
  const isArch = Boolean(item.Archive ?? item.archive);
  return {
    id: item.ID || item.id,
    name: item.Name || item.name || '',
    alias: item.Aliase || item.alias || '',
    color: item.ColorCode || item.color || '#3B82F6',
    archive: isArch,
    status: item.status || (isArch ? 'Inactive' : 'Active'),
  };
}

export const leaveMasterApi = {
  getRecords: async (filters = {}) => {
    const params = {
      search: filters.searchText || undefined,
      search_field: filters.searchField || undefined,
      status_filter: filters.status || 'Active',
      page: filters.page || 1,
      page_size: filters.pageSize || 10,
    };
    const { data } = await api.get('/payroll/leave-master/', { params });
    const rawItems = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    return {
      items: rawItems.map(mapBackendToFrontend),
      total_count: data?.total_count ?? rawItems.length,
      total_pages: data?.total_pages ?? 1,
      page: data?.page ?? (filters.page || 1),
      page_size: data?.page_size ?? (filters.pageSize || 10),
    };
  },

  getRecordById: async (id) => {
    const { data } = await api.get(`/payroll/leave-master/${id}`);
    return mapBackendToFrontend(data);
  },

  createRecord: async (payload) => {
    const body = {
      Name: payload.name,
      Aliase: payload.alias || null,
      ColorCode: payload.color || '#3B82F6',
    };
    const { data } = await api.post('/payroll/leave-master/', body);
    return data;
  },

  updateRecord: async (id, payload) => {
    const body = {
      Name: payload.name,
      Aliase: payload.alias || null,
      ColorCode: payload.color || '#3B82F6',
    };
    const { data } = await api.put(`/payroll/leave-master/${id}`, body);
    return data;
  },

  archiveRecord: async (id) => {
    const { data } = await api.patch(`/payroll/leave-master/${id}/archive`);
    return data;
  },

  deleteRecord: async (id) => {
    const { data } = await api.delete(`/payroll/leave-master/${id}`);
    return data;
  },
};
